import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from "./components/header/header.component";
import {FlexLayoutModule} from "@angular/flex-layout";
import {NavStepsComponent} from './components/header/nav-steps/nav-steps.component';
import {RouterModule} from "@angular/router";
import {PageLoaderComponent} from "./components/page-loader/page-loader.component";
import {ToastModule} from "primeng/toast";
import {MessageService} from "primeng/api";

@NgModule({
  declarations: [
    HeaderComponent,
    NavStepsComponent,
    PageLoaderComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    ToastModule,
  ],
  exports: [
    HeaderComponent,
    PageLoaderComponent,
  ],
  providers: [
    MessageService,
  ]
})
export class AppSharedModule {
}
